export default {
  namespaced: true,
  state: {
    message: '',
    color: 'success',
    show: false
  },

  mutations: {
    setMessage(state, config) {
      state.message = config.message
      state.color = config.color
      state.show = true
    },

    clearMessage(state) {
      state.message = ''
      state.color = 'success'
      state.show = false
    }
  },

  actions: {
    setAlert({ commit }, message, color) {
      commit('setMessage', message, color)
    }
  }
}
